import { Controller, type Control, type FieldValues, type Path } from 'react-hook-form';
import { Label, Input } from '@shared/components';

interface Props<T extends FieldValues> {
    control: Control<T>;
}

export function CustomerContactFields<T extends FieldValues>({ control }: Props<T>) {
    return (
        <>
            <Controller
                name={'email' as Path<T>}
                control={control}
                render={({ field, fieldState }) => (
                    <div>
                        <Label htmlFor="email">Email</Label>
                        <Input
                            id="email"
                            type="email"
                            {...field}
                            error={!!fieldState.error}
                            hint={fieldState.error?.message}
                        />
                    </div>
                )}
            />
            <Controller
                name={'mobilePhone' as Path<T>}
                control={control}
                render={({ field, fieldState }) => (
                    <div>
                        <Label htmlFor="mobilePhone">Mobile Phone *</Label>
                        <Input
                            id="mobilePhone"
                            type="tel"
                            aria-required
                            {...field}
                            error={!!fieldState.error}
                            hint={fieldState.error?.message}
                        />
                    </div>
                )}
            />
        </>
    );
}
